"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AuthTypeEnum: function() {
        return _constants.AuthTypeEnum;
    },
    getTracking: function() {
        return getTracking;
    }
});
var _trackSignup = require("./trackSignup");
var _trackLogin = require("./trackLogin");
var _updateUser = require("./updateUser");
var _segment = require("./util/segment");
var _updateLastLogin = require("./updateLastLogin");
var _trackVerified = require("./trackVerified");
var _constants = require("./constants");
var getTracking = function() {
    var prefix = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return {
        resetUser: _segment.resetUser,
        updateUser: function(data) {
            return (0, _updateUser.updateUser)(prefix, data);
        },
        updateLastLogin: function(data) {
            return (0, _updateLastLogin.updateLastLogin)(prefix, data);
        },
        trackSignup: function(type, data) {
            return (0, _trackSignup.trackSignup)(prefix, type, data);
        },
        trackLogin: function(type, data) {
            return (0, _trackLogin.trackLogin)(prefix, type, data);
        },
        trackVerified: function(data) {
            return (0, _trackVerified.trackVerified)(prefix, data);
        }
    };
};

//# sourceMappingURL=index.js.map